<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>{{ $t("Generate.Generate_DTA") }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="py-0">
            <v-form ref="form" v-model="valid">
              <v-container>
                <v-row justify="space-around">
                  <v-col cols="6">
                    <v-text-field
                      :label="$t('Generate.SiteId')"
                      v-model="site.siteId"
                      :rules="[
                        v => !!v || $t('Rules.SiteId_generate_required')
                      ]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      :label="$t('Generate.APIKey')"
                      v-model="site.apikey"
                      :rules="[v => !!v || $t('Rules.APIKey_required')]"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="primary"
              :disabled="!valid"
              v-on:click="downloadDTA"
              >{{ $t("Generate.Validate") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import DTAGenerationHelper from "@/helpers/DTAGenerationHelper";

export default {
  data() {
    return {
      valid: false,
      site: {
        siteId: "",
        apikey: ""
      }
    };
  },
  methods: {
    downloadDTA(site) {
      DTAGenerationHelper.DownloadDTA(this.site, false);
    }
  }
};
</script>
